import * as React from 'react';

import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Bs4Tooltip from '../Bs4Components/Bs4Tooltip';


export const Bs4ReportViewIcon = (props) => {

  const handleShow = (e) => {
    if (props.onShow) props.onShow(e);
    if (props.onCloseClick) props.onCloseClick(e);
  }

  const handleRemember = (e) => {
    if (props.onRemember) props.onRemember(e);
    if (props.onCloseClick) props.onCloseClick(e);
  }

  const handleReset = (e) => {
    if (props.onReset(e)) props.onReset(e);
    if (props.onCloseClick) props.onCloseClick(e);
  }

  return (
    <Stack sx={props.sx} direction="row" justifyContent="flex-start" alignItems="center" spacing={props.spacing || 0.5}>
      <Bs4Tooltip title={'Pokaż'} arrow describeChild>
        <IconButton onClick={handleShow}><i className="fa-regular fa-arrows-rotate" style={{fontSize: '0.875rem'}}></i></IconButton>
      </Bs4Tooltip>
      <Bs4Tooltip title={'Pamiętaj'} arrow describeChild>
        <IconButton onClick={handleRemember}><i className="fa-regular fa-thumbtack" style={{fontSize: '0.875rem'}}></i></IconButton>
      </Bs4Tooltip>
      <Bs4Tooltip title={'Resetuj'} arrow describeChild>
        <IconButton onClick={handleReset}><i className="fa-regular fa-eraser" style={{fontSize: '0.875rem'}}></i></IconButton>
      </Bs4Tooltip>
    </Stack>        
  )
}

export default Bs4ReportViewIcon;